var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.loading)?_c('LoadingState',{attrs:{"loading":_vm.loading}}):_vm._e(),_c('v-container',{attrs:{"grid-list-xl":"","fluid":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('stores-list'),_c('settings-options-grid')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }